import React, { useState } from "react";
import { createRoot } from "react-dom";
import { useNavigate } from "react-router-dom";
import  BubblyBubbles  from "./BubblyBubbles";

const BubblyLink = ({
  to,
  children,
  setVisible,
  colorStart = "#8f44fd",
  colorEnd = "#ffffff",
  duration = 0,
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate(to);

    setTimeout(() => {
      let pipelineNavs = document.querySelectorAll(".pipelineNavs")
      pipelineNavs.forEach((item)=> {
        item.parentElement.style.pointerEvents = `none`
      })
    }, 100);

    setTimeout(() => {
      let pipelineNavs = document.querySelectorAll(".pipelineNavs")
      pipelineNavs.forEach((item)=> {
        item.parentElement.style.pointerEvents = `auto`
      })
    }, 1500);
    setVisible(false)
  };

  return (
    <button
    style={{height: "50px", minWidth: "40px"}}
      type="button"
      className={`react-bubbly-transitions__bubbly-link ${
        window.location.pathname === to ? "active" : ""
      }`}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

export default BubblyLink;
